import { render, staticRenderFns } from "./GroupPicker.vue?vue&type=template&id=fa130592"
import script from "./GroupPicker.vue?vue&type=script&setup=true&lang=ts"
export * from "./GroupPicker.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports